import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_OFFER, GET_OFFER_BY_ID } from "../constants";

/*
 * The backend returns errors in three shapes:
 *   422 ServiceError    -> { status: false, message: "Offer with this name already exists" }
 *   400 ValidationError -> { status: false, response: ["Invalid discount_value. ...", ...] }
 *   500 Exception       -> { status: false, response: { message: "something went wrong..." } }
 * axios throws on all of them, so every catch below funnels through this
 * extractor — the admin always sees a human-readable sentence, never silence.
 */
const friendlyError = (err) => {
  const data = err?.response?.data;
  const resp = data?.response;
  if (Array.isArray(resp) && resp.length) return resp.join("\n");
  if (typeof resp === "string" && resp) return resp;
  if (resp?.message) return resp.message;
  if (data?.message) return data.message;
  if (err?.message === "Network Error")
    return "Can't reach the server. Please check your internet connection and try again.";
  return "Something went wrong on our side. Please try again in a moment.";
};

const showError = (err) =>
  swal({
    text: friendlyError(err),
    icon: "error",
    button: "Close",
  });

export const getOffer = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/offers`, { params: data });
    if (response?.data?.status) {
      dispatch({ type: GET_OFFER, offerlist: response?.data?.response });
    } else {
      dispatch({ type: GET_OFFER, offerlist: [] });
    }
  } catch (err) {
    // An empty list is a normal state for the list page ("No offers found"
    // is a 422 from the backend) — only real failures get a popup.
    dispatch({ type: GET_OFFER, offerlist: [] });
  }
};

export const addOffer = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/offers", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Coupon created successfully",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/offerlist");
      return response;
    }
    showError({ response: { data: response?.data } });
  } catch (err) {
    showError(err);
  } finally {
    setLoading(false);
  }
};

export const updateOffer = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("admin/offers", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Coupon updated successfully",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/offerlist");
      return response;
    }
    showError({ response: { data: response?.data } });
  } catch (err) {
    showError(err);
  } finally {
    setLoading(false);
  }
};

export const deleteOffer = (id, setLoading, onSuccess) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`admin/offers/${id}`);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Coupon deleted",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      if (onSuccess) onSuccess();
      window.location.reload();
      return;
    }
    showError({ response: { data: response?.data } });
  } catch (err) {
    showError(err);
  } finally {
    setLoading(false);
  }
};

export const getOfferById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/offers/${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_OFFER_BY_ID, offerbyid: response.data.response });
      return response;
    }
    showError({ response: { data: response?.data } });
  } catch (err) {
    showError(err);
  }
};
